module.exports = __webpack_public_path__ + "static/media/cargar.eddf34fd.svg";